import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ManageContainerEditorPage } from './manage-container-editor.page';

const routes: Routes = [
  {
    path: '',
    component: ManageContainerEditorPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ManageContainerEditorPageRoutingModule {}
